import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { FaAngleRight } from 'react-icons/fa6';

import quizBgImg from './quiz-bg.webp';

type QuizCardProps = {
  title: string;
  quizId?: string;
  onClick: () => void;
};

export const QuizCard: FC<QuizCardProps> = ({ title, onClick, quizId }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: '8px',
        width: { xs: '100%', md: '285px' },
        height: { xs: '100%', md: '102px' },
        display: 'flex',
        alignItems: 'center',
        backgroundImage: `url(${quizBgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box sx={{ px: 1.4, py: 1.7, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="caption" sx={{ fontWeight: 'bold', lineHeight: '1.4', color: theme.palette.grey[900] }}>
          {title || 'Quiz'}
        </Typography>
        <Typography variant="caption" sx={{ color: theme.palette.grey[900] }}>
          Test your knowledge
        </Typography>
        <Button
          variant="text"
          color="primary"
          size="small"
          disabled={!quizId}
          onClick={onClick}
          endIcon={<FaAngleRight size={12} />}
          sx={{
            p: 0,
            minHeight: '20px',
            fontWeight: 'bold',
            fontSize: '11px',
            alignSelf: 'flex-start',
            color: theme.palette.primary.main,
          }}
        >
          Start
        </Button>
      </Box>
    </Box>
  );
};
